// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const progerssBarColor = (props) => {
  if (props.hideProgressBar) {
    return 'transparent';
  }
  return props.theme.colorPalette.blue[800];
};

const progerssBarBgColor = (props) => {
  if (props.hideProgressBar || (props.isPerkNotReached && !props.isPlcc)) {
    return 'transparent';
  }

  return props.theme.colorPalette.gray[3600];
};

const starFillColor = (props) => {
  if (props.isPerkNotReached && !props.isPlcc) {
    return '#A8A8A8';
  }

  switch (props.variant) {
    case 'star':
      return props.theme.colorPalette.blue[1800];
    case 'rockstar':
      return props.theme.colorPalette.blue[300];
    case 'superstar':
      return props.theme.colorPalette.blue[1900];
    case 'megastar':
      return props.theme.colorPalette.blue[800];
    case 'plccmegastar':
      return props.theme.colorPalette.blue[200];
    default:
      return '#A8A8A8';
  }
};

const starSize = (props) => {
  switch (props.size) {
    case 'small':
      return '30px';
    case 'medium':
      return '52px';
    case 'large':
      return '100px';
    default:
      return '100px';
  }
};

const starMarginTop = (props) => {
  switch (props.size) {
    case 'small':
      return '-2px';
    default:
      return '-4px';
  }
};

const progressCircleSize = (props, divisor = 1) => {
  switch (props.size) {
    case 'small':
      return `${50 / divisor}px`;
    case 'medium':
      return `${88 / divisor}px`;
    case 'large':
      return `${160 / divisor}px`;
    default:
      return `${160 / divisor}px`;
  }
};

const progressBarSize = (props) => {
  switch (props.size) {
    case 'small':
      return '4px';
    case 'medium':
      return '8px';
    case 'large':
      return '12px';
    default:
      return '12px';
  }
};

const contentSize = (props) => {
  switch (props.size) {
    case 'small':
      return '44px';
    case 'medium':
      return '74px';
    case 'large':
      return '138px';
    default:
      return '138px';
  }
};

const contentAlignmentSize = (props) => {
  switch (props.size) {
    case 'small':
      return '3px';
    case 'medium':
      return '7px';
    case 'large':
      return '11px';
    default:
      return '11px';
  }
};

const earnedPointFontSize = (props) => {
  switch (props.size) {
    case 'small':
      return 'fs10';
    case 'medium':
      return 'fs16';
    case 'large':
      return 'fs24';
    default:
      return 'fs24';
  }
};

const earnedPointDollarFontSize = (props) => {
  switch (props.size) {
    case 'small':
      return 'fs8';
    case 'medium':
      return 'fs12';
    case 'large':
      return 'fs14';
    default:
      return 'fs14';
  }
};

const maxPointFontSize = (props) => {
  switch (props.size) {
    case 'small':
      return 'fs10';
    case 'medium':
      return 'fs12';
    case 'large':
      return 'fs24';
    default:
      return 'fs24';
  }
};

const starDropShadow = (props) => {
  switch (props.size) {
    case 'small':
      return '2px 1px';
    case 'medium':
      return '3px 2px';
    case 'large':
      return '4px 3px';
    default:
      return '4px 3px';
  }
};

const styles = css`
  .perks-dollar-symbol {
    font-size: ${(props) => props.theme.typography.fontSizes[earnedPointDollarFontSize(props)]};
  }

  .perks-earned-point {
    font-size: ${(props) => props.theme.typography.fontSizes[earnedPointFontSize(props)]};
    font-weight: ${(props) => props.theme.typography.fontWeights.bold};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
  }

  .perks-max-point {
    font-size: ${(props) => props.theme.typography.fontSizes[maxPointFontSize(props)]};
    font-weight: ${(props) => props.theme.typography.fontWeights.regular};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
  }

  .star {
    ${(props) =>
      !props.isPerkNotReached && props.hideProgressBar && props.variant !== undefined
        ? `filter: drop-shadow(${starDropShadow(props)} ${props.theme.colorPalette.blue[1600]})`
        : props.isPerkNotReached &&
          !props.isPlcc &&
          `filter: drop-shadow(${starDropShadow(props)} #8F8F8F)`};
  }
  .star-border {
    fill: ${(props) => props.theme.colorPalette.gray[3900]};
  }

  .progress-circle.over50 .star-border {
    fill: ${(props) => props.theme.colorPalette.gray[3900]};
  }

  .star-fill {
    fill: ${(props) => starFillColor(props)};
  }

  svg {
    width: ${(props) => starSize(props)};
    margin-top: ${(props) => starMarginTop(props)};
  }

  .progress-circle {
    position: relative;
    padding: 0;
    width: ${(props) => progressCircleSize(props)};
    height: ${(props) => progressCircleSize(props)};
    background-color: ${(props) => progerssBarBgColor(props)};
    border-radius: 50%;
  }

  .progress-circle:after {
    border: none;
    position: absolute;
    top: ${(props) => contentAlignmentSize(props)};
    left: ${(props) => contentAlignmentSize(props)};
    text-align: center;
    display: block;
    border-radius: 50%;
    width: ${(props) => contentSize(props)};
    height: ${(props) => contentSize(props)};
    background-color: ${(props) =>
      !props.isPerkNotReached ? props.theme.colorPalette.white : 'none'};
    content: ' ';
  }

  .progress-circle .progress-text {
    position: absolute;
    top: 0;
    width: ${(props) => progressCircleSize(props)};
    height: ${(props) => progressCircleSize(props)};
    display: flex;
    z-index: 2;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-direction: column;
  }

  .progress-circle .star-image span {
    position: absolute;
    top: 0;
    width: ${(props) => progressCircleSize(props)};
    height: ${(props) => progressCircleSize(props)};
    display: flex;
    color: ${(props) => progerssBarColor(props)};
    z-index: 2;
    justify-content: center;
    align-items: center;
    align-content: center;
  }

  .left-half-clipper {
    border-radius: 50%;
    width: ${(props) => progressCircleSize(props)};
    height: ${(props) => progressCircleSize(props)};
    position: absolute;
    clip: rect(
      0,
      ${(props) => progressCircleSize(props)},
      ${(props) => progressCircleSize(props)},
      ${(props) => progressCircleSize(props, 2)}
    );
  }

  /* when percentage is 50, don't clip left half*/
  .progress-circle.over50 .left-half-clipper {
    clip: rect(auto, auto, auto, auto);
  }
  .value-bar {
    position: absolute;
    clip: rect(
      0,
      ${(props) => progressCircleSize(props, 2)},
      ${(props) => progressCircleSize(props)},
      0
    );
    width: ${(props) => progressCircleSize(props)};
    height: ${(props) => progressCircleSize(props)};
    border-radius: 50%;
    border: ${(props) => progressBarSize(props)} solid ${(props) => progerssBarColor(props)};
    box-sizing: border-box;
  }

  /* Progress bar filling the whole right half for values above 50% */
  .progress-circle.over50 .first50-bar {
    position: absolute;
    clip: rect(
      0,
      ${(props) => progressCircleSize(props)},
      ${(props) => progressCircleSize(props)},
      ${(props) => progressCircleSize(props, 2)}
    );
    background-color: ${(props) => progerssBarColor(props)};
    border-radius: 50%;
    width: ${(props) => progressCircleSize(props)};
    height: ${(props) => progressCircleSize(props)};
  }
  .progress-circle:not(.over50) .first50-bar {
    display: none;
  }
  .progress-circle .value-bar {
    transform: rotate(${(props) => Math.round(props.percentage * 3.6)}deg);
  }
`;

export default styles;
